export const iconButtonStyle = {
  textTransform: "none",
  color: "#ffffff",
  background: "#3671E9",
  borderRadius: "2rem",
  ":hover": {
    background: "#3671E9",
    transform: "scale(1.05)",
    transition: ".5s",
  },
  fontSize: 18,
  fontWeight: 500,
};
